import { ResetTrip } from './ResetTrip';
import { ResetRegistrationNumber } from './ResetRegistrationNumber';

export default {
    ResetTrip,
    ResetRegistrationNumber
}